
import FilesDataGrid from "./FilesDataGrid";
import { DataDwellingInfos } from "../../interfaces";

type DwellingFilesProps = {
  dwelling: DataDwellingInfos;
  onDeleteFile?: (fileId: string) => void;
  isDeleting?: boolean;
  deletingFileId?: string;
};

const DwellingFiles: React.FC<DwellingFilesProps> = ({ dwelling, onDeleteFile, isDeleting, deletingFileId }) => {
  return (
    <div className="bg-container">
      <div className="propertySheetDetailsPartTitle mb-3">Documents</div>
      <FilesDataGrid 
        id={dwelling.id} 
        files={dwelling?.files} 
        onDelete={onDeleteFile} 
        isDeleting={isDeleting}
        deletingFileId={deletingFileId}
      />
    </div>
  );
};

export default DwellingFiles;
